module.exports = __webpack_public_path__ + "img/Provident Fund.ba4a03d7.png";